import React from 'react';
import { Megaphone } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

export const PromotionView: React.FC<{ loading: boolean; data: any }> = ({ loading, data }) => {
  if (loading) return <Skeleton className="h-24 w-full" />;
  if (!data) return <p className="py-8 text-center text-sm text-gray-400">This listing has no active promotion.</p>;
  return (
    <div className="rounded-xl border border-blue-100 bg-blue-50/50 p-5">
      <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-blue-800">
        <Megaphone className="h-4 w-4" /> Active promotion
      </div>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
        {Object.entries(data)
          .filter(([, v]) => v !== null && typeof v !== 'object')
          .slice(0, 9)
          .map(([k, v]) => (
            <div key={k}>
              <p className="text-[11px] uppercase tracking-wide text-blue-400">{k.replace(/_/g, ' ')}</p>
              <p className="text-sm text-gray-800">{String(v)}</p>
            </div>
          ))}
      </div>
    </div>
  );
};
